//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class LibraryLendingItemHistoryDisplayItem extends ItemBase {
    DateLoaned: string | null = null;
    DateReturned: string | null = null;
    ID: string | null = null;
    ItemName: string | null = null;
    ItemType: string | null = null;
    LoanedByTeacherName: string | null = null;
    ReturnedByTeacherName: string | null = null;
    StudentName: string | null = null;

    constructor(initializer?: Partial<LibraryLendingItemHistoryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "LibraryLendingItemHistoryDisplayItem";
}
